import React from "react";
import { altColor, secondaryTextColorOppositeShade } from "../../utils/constants";

export default function LevelUpIcon({ color = altColor, color2 = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393.86 393.86">
      <defs>
        <radialGradient
          id="Unbenannter_Verlauf_2"
          cx="238.43"
          cy="-1353.78"
          r="194.95"
          gradientTransform="matrix(1, 0, 0, -1, -41.5, -1156.85)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color={color} />
          <stop offset="1" stop-color={color} />
        </radialGradient>
      </defs>
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <g id="Ebene_2-2" data-name="Ebene 2">
            <g id="Ebene_1-2-2" data-name="Ebene 1-2">
              <circle
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth="3.97px"
                fill="url(#Unbenannter_Verlauf_2)"
                cx="196.93"
                cy="196.93"
                r="194.95"
              />
            </g>
          </g>
          <g id="Layer_22" data-name="Layer 22">
            <path
              fill={color2}
              d="M153,125.51l16.1-.07.57,128.77a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4l-.59-132.79a4,4,0,0,0-4-4l-10.42,0L197.1,82.7l34.72,34.41-10.42,0a4,4,0,0,0-4,4L218,254a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4l-.57-128.77,16.09-.08a4,4,0,0,0,2.83-6.89L199.92,74.16a4,4,0,0,0-5.69,0l0,0-44.07,44.46a4.05,4.05,0,0,0,2.89,6.87Z"
            />
            <path
              fill={color2}
              d="M189.42,206.61h0a4,4,0,0,1,4,4v59.47a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V210.64A4,4,0,0,1,189.42,206.61Z"
            />
            <path
              fill={color2}
              d="M205.52,177.67h0a4,4,0,0,1,4,4v88.41a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V181.7A4,4,0,0,1,205.52,177.67Z"
            />
            <path
              fill={color2}
              d="M242.4,237.8h16.09v56.33a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4V233.77a4,4,0,0,0-4-4H252.1l34.56-34.57,34.56,34.57H310.8a4,4,0,0,0-4,4v60.36a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4V237.8h16.09a4.05,4.05,0,0,0,2.86-6.88l-44.26-44.27a4,4,0,0,0-5.69,0l0,0-44.26,44.27a4.05,4.05,0,0,0,2.86,6.88Z"
            />
            <path
              fill={color2}
              d="M294.71,274h0a4,4,0,0,1,4,4v24.15a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V278A4,4,0,0,1,294.71,274Z"
            />
            <path
              fill={color2}
              d="M278.61,249.87h0a4,4,0,0,1,4,4v48.29a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V253.89A4,4,0,0,1,278.61,249.87Z"
            />
            <path
              fill={color2}
              d="M64.7,237.81H80.8v56.33a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4V233.78a4,4,0,0,0-4-4H74.4L109,195.2l34.57,34.56H133.1a4,4,0,0,0-4,4v60.36a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4V237.81h16.09a4.05,4.05,0,0,0,2.86-6.88l-44.26-44.26a4,4,0,0,0-5.69,0l0,0L61.84,230.93a4.05,4.05,0,0,0,2.86,6.88Z"
            />
            <path
              fill={color2}
              d="M117,274h0a4,4,0,0,1,4,4v24.15a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V278A4,4,0,0,1,117,274Z"
            />
            <path
              fill={color2}
              d="M100.91,249.88h0a4,4,0,0,1,4,4v48.29a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V253.9A4,4,0,0,1,100.91,249.88Z"
            />
          </g>
          <path
            fill={color2}
            d="M286.42,149.75a2.68,2.68,0,0,0,0-4.78l-2.32-1.16a13.42,13.42,0,0,1-6-6L277,135.53a2.68,2.68,0,0,0-4.78,0L271,137.85a13.42,13.42,0,0,1-6,6L262.76,145a2.68,2.68,0,0,0,0,4.78l2.32,1.16a13.42,13.42,0,0,1,6,6l1.16,2.32a2.68,2.68,0,0,0,4.78,0l1.16-2.32a13.42,13.42,0,0,1,6-6Zm-11.83,3.72a18.25,18.25,0,0,0-6.12-6.11,18.25,18.25,0,0,0,6.12-6.11,18.22,18.22,0,0,0,6.11,6.11A18.22,18.22,0,0,0,274.59,153.47Z"
          />
          <path
            fill={color2}
            d="M317.41,107.41a4.21,4.21,0,0,0,0-7.54L313.75,98a21.22,21.22,0,0,1-9.42-9.41L302.5,85A4.21,4.21,0,0,0,295,85l-1.83,3.66A21.17,21.17,0,0,1,283.71,98l-3.66,1.83a4.21,4.21,0,0,0,0,7.54l3.66,1.83a21.19,21.19,0,0,1,9.42,9.42l1.83,3.66a4.21,4.21,0,0,0,7.54,0l1.83-3.66a21.24,21.24,0,0,1,9.42-9.42Zm-18.68,5.89a28.85,28.85,0,0,0-9.65-9.66A28.73,28.73,0,0,0,298.73,94a28.76,28.76,0,0,0,9.66,9.65A28.79,28.79,0,0,0,298.73,113.3Z"
          />
          <path
            fill={color2}
            d="M117.1,138.52a5.58,5.58,0,0,0,0-10l-4.84-2.42A28,28,0,0,1,99.8,113.68l-2.42-4.84a5.57,5.57,0,0,0-10,0L85,113.68a28,28,0,0,1-12.45,12.45l-4.84,2.42a5.57,5.57,0,0,0,0,10l4.84,2.42A28,28,0,0,1,85,153.39l2.42,4.84a5.57,5.57,0,0,0,10,0l2.42-4.84a28,28,0,0,1,12.45-12.45ZM92.4,146.3a38,38,0,0,0-12.76-12.76A38.1,38.1,0,0,0,92.4,120.77a38.22,38.22,0,0,0,12.77,12.77A38.1,38.1,0,0,0,92.4,146.3Z"
          />
        </g>
      </g>
    </svg>
  );
}
